// ----------------------------------------------------------------------------
// Component: Two Column Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_two-column-block.scss';
